/**
 * The tokens `private.render_message_tokens` actually substitutes.
 *
 * Kept here as the single client-side list so a composer cannot offer a token
 * the server does not understand, an unsupported token is stripped on send,
 * so offering one would silently delete text the user typed.
 */
export const MESSAGE_TOKENS: { token: string; label: string }[] = [
  { token: "{{first_name}}", label: "First name" },
  { token: "{{last_name}}", label: "Last name" },
  { token: "{{name}}", label: "Full name" },
  { token: "{{company}}", label: "Company" },
  { token: "{{workspace_name}}", label: "Your business" },
];
